 /**
 * Flattens a Strapi-like object structure by removing 'data' and 'attributes' fields.
 * @param {Object} obj - The object to flatten.
 * @returns {Object} The flattened object.
 */
 export function flattenStrapiData(obj) {
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(flattenStrapiData);
  }

  let result = {};

  // Handle the case filters the object has a 'data' property
  if (obj.data !== undefined) {
    return flattenStrapiData(obj.data);
  }

  for (const [key, value] of Object.entries(obj)) {
    if (key === 'attributes') {
      Object.assign(result, flattenStrapiData(value));
    } else if (typeof value === 'object' && value !== null) {
      result[key] = flattenStrapiData(value);
    } else {
      result[key] = value;
    }
  }

  return result;
}